import { Zodios, ZodiosInstance } from '@zodios/core';
import { ZodiosHooks, ZodiosHooksInstance } from '@zodios/react';
import { endpoints } from 'api';
import apiErrorPlugin from 'api/api-error-plugin';
import apiTokenPlugin from 'api/api-token-plugin';
import { PropsWithChildren, createContext, useContext } from 'react';
import { useSupabase } from './supabase-provider';

interface ApiContextType {
  apiClient: ZodiosInstance<typeof endpoints>;
  api: ZodiosHooksInstance<typeof endpoints>;
}

const ApiContext = createContext<ApiContextType | undefined>(undefined);

interface ApiProviderProps extends PropsWithChildren {
  baseUrl: string;
}

export function ApiProvider({ baseUrl, children }: ApiProviderProps) {
  const supabase = useSupabase();

  const apiClient = new Zodios(baseUrl, endpoints);
  apiClient.use(apiErrorPlugin);
  apiClient.use(apiTokenPlugin(supabase));
  const api = new ZodiosHooks('endpoints', apiClient);

  return (
    <ApiContext.Provider value={{ api, apiClient }}>
      {children}
    </ApiContext.Provider>
  );
}

export function useApi() {
  const context = useContext(ApiContext);
  if (!context) throw new Error('useUser must be used within an UserProvider');
  return context;
}
